import { defineRouteMetadata } from "@pax/contract-kit";

export { type ContractService, errors, pathFor } from "@pax/contract-kit";

type ContractAuth =
  /** The browser's sign-in cookie, which the asset editor has the Product API check. */
  | { kind: "session"; detail: string }
  | { kind: "service"; detail: string; caller: "api"; scope: "basemaps:manage" };

export interface PaxRouteMetadata {
  auth: ContractAuth;
  policy?: {
    session?: true;
  };
}

export const { paxRoute, getPaxRouteMetadata } = defineRouteMetadata<PaxRouteMetadata>();
